import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const OutrosServicos = () => {

    const { t } = useTranslation();
    return (
        <>
            <div className="row row-35">
                {/* projectpropone */}
                <div className="col-md-6">

                    <div style={{ cursor: "pointer" }}>
                        <div className={`project-grid`}>
                            <div className="thumbnail_custom">
                                <Link to={`/service-details/Eletricite`}>
                                    <img src={process.env.PUBLIC_URL + "/images/services/eletricidade.webp"} alt="icon" style={{ borderRadius: "10px", height: "300px", width:"610px" }} />
                                </Link>
                            </div>
                            <div className="content">
                                <p className="title h4">
                                    <Link to={`/service-details/Eletricite`}>{t('Electricité')}</Link>
                                </p>
                                <span className="subtitle">
                                    {t('ElectriciteDescription')}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div style={{ cursor: "pointer" }}>
                        <div className={`project-grid`}>
                            <div className="thumbnail_custom">
                                <Link to={`/service-details/Energie_Renouvelable`}>
                                    <img src={process.env.PUBLIC_URL + "/images/services/energia_renovavel.webp"} alt="icon" style={{ borderRadius: "10px", height: "300px", width:"610px" }} />
                                </Link>
                            </div>
                            <div className="content">
                                <p className="title h4">
                                    <Link to={`/service-details/Energie_Renouvelable`}>{t('Energie renouvelable')}</Link>
                                </p>
                                <span className="subtitle">
                                    {t('EnergieDescription')}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div className="row row-35 justify-content-md-center">
                <div className="col-md-6">
                    <div style={{ cursor: "pointer" }}>
                        <div className={`project-grid`}>
                            <div className="thumbnail_custom">
                                <Link to={`/service-details/Informatique`}>
                                    <img src={process.env.PUBLIC_URL + "/images/services/informatique.webp"} alt="icon" style={{ borderRadius: "10px", height: "300px", width:"610px" }} />
                                </Link>
                            </div>
                            <div className="content">
                                <p className="title h4">
                                    <Link to={`/service-details/Informatique`}>{t('Informatique')}</Link>
                                </p>
                                <span className="subtitle">
                                    {t('InformatiqueDescription')}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default OutrosServicos;